exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\niframe {\n  /*width: 100%;*/\n  max-width: 800px; /* Also helpful. Optional. */\n}\n\n", ""]);

// exports
